import { createUseStyles } from "react-jss";
import { colors } from "../../../../styles/colors";

const useStyles = createUseStyles((_) => ({
  contentMain: {
    overflow: "auto",
    height: "var(--app-vh)",
  },
  historyRoot: {
    padding: "20px clamp(16px, 3vw, 30px)",
    minHeight: "var(--app-vh)",
    backgroundColor: colors.bgcolor,
    "@media (max-width:899.95px)": { paddingTop: "68px" },
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    minHeight: "100%",
    paddingBottom: "30px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  headerSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    padding: "20px 24px",
    backgroundColor: colors.surface,
    borderRadius: "14px",
    border: `1px solid ${colors.borderLight}`,
  },
  headerLeft: {
    display: "flex",
    alignItems: "flex-start",
    gap: "15px",
    flex: 1,
  },
  headerButton: {
    flexShrink: 0,
    "& button": {
      minWidth: "fit-content",
      maxWidth: "280px",
      whiteSpace: "nowrap",
      width: "auto",
    },
  },
  backButton: {
    marginTop: "5px",
  },
  titleSection: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  vehicleInfo: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginTop: "10px",
  },
  statsSection: {
    // Grille plutot que flex : les cartes remplissent la largeur au lieu de
    // flotter en deux petits blocs colles a gauche avec un grand vide a
    // droite. auto-fit laisse la grille choisir le nombre de colonnes.
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "20px",
    // marginBottom retire : il s'ajoutait au gap de 20px du conteneur, ce qui
    // creait un ecart de 40px sous les stats et de 20px partout ailleurs.
  },
  statCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    gap: "4px",
    padding: "20px 24px",
    backgroundColor: colors.surface,
    borderRadius: "14px",
    border: `1px solid ${colors.borderLight}`,
    // textAlign center + alignItems center centraient un chiffre et son
    // libelle dans une carte large : l'oeil doit repartir a la ligne pour
    // chaque carte. Aligne a gauche, les valeurs forment une colonne
    // parcourable.
    textAlign: "left",
    transition: "transform 0.2s ease, border-color 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      borderColor: "rgba(37,99,235,0.35)",
    },
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "40px",
    backgroundColor: colors.surface,
    borderRadius: "14px",
    border: `1px solid ${colors.borderLight}`,
  },
  errorContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    padding: "48px 40px",
    backgroundColor: colors.surface,
    borderRadius: "14px",
    border: `1px solid ${colors.borderLight}`,
    textAlign: "center",
    "& button": {
      minWidth: "fit-content",
      maxWidth: "240px",
    },
  },
  emptyContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",
    padding: "64px 40px",
    backgroundColor: colors.surface,
    borderRadius: "14px",
    border: `1px solid ${colors.borderLight}`,
    textAlign: "center",
    "& button": {
      minWidth: "fit-content",
      maxWidth: "260px",
      marginTop: "8px",
    },
  },
  emptyIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "72px",
    height: "72px",
    borderRadius: "50%",
    backgroundColor: colors.bgcolor,
    opacity: 0.9,
    marginBottom: "4px",
  },
  tableContainer: {
    backgroundColor: colors.surface,
    borderRadius: "14px",
    border: `1px solid ${colors.borderLight}`,
    overflow: "hidden",
    flex: "0 0 auto",
    // minHeight 400px retire : sur un vehicule avec une seule intervention,
    // il reservait ~300px de blanc sous l'unique ligne, ce qui donnait
    // l'impression d'un tableau qui n'a pas fini de charger. Le conteneur
    // s'ajuste maintenant a son contenu.
  },
  quickActions: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    padding: "20px 24px",
    backgroundColor: colors.surface,
    borderRadius: "14px",
    border: `1px solid ${colors.borderLight}`,
  },
  actionButtons: {
    display: "flex",
    gap: "12px",
    flexWrap: "wrap",
    "& button": {
      minWidth: "fit-content",
      maxWidth: "220px",
      whiteSpace: "nowrap",
    },
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    borderTop: '1px solid rgba(0, 0, 0, 0.08)',
    backgroundColor: 'rgba(0, 0, 0, 0.01)',
    gap: '16px',
    flexWrap: 'wrap',
  },
  paginationInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    flexWrap: 'wrap',
  },
  paginationButtons: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
    "& button": {
      minWidth: "fit-content",
      maxWidth: "140px",
      whiteSpace: "nowrap",
    },
  },
  perPageSelector: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  perPageSelect: {
    padding: '8px 16px',
    borderRadius: '8px',
    border: `1px solid ${colors.borderLight}`,
    backgroundColor: colors.surfaceElevated,
    color: colors.primaryText,
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.2s ease',
    outline: 'none',
    '&:hover': {
      borderColor: colors.borderDark,
      backgroundColor: colors.surfaceHover,
    },
    '&:focus': {
      borderColor: colors.primary || '#1976d2',
      boxShadow: '0 0 0 3px rgba(37, 99, 235, 0.18)',
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
      backgroundColor: colors.surfaceElevated,
    },
  },
  
  // Responsive design
  "@media (max-width: 960px)": {
    headerSection: {
      flexDirection: "column",
      gap: "15px",
      alignItems: "stretch",
    },
    headerButton: {
      "& button": {
        width: "100%",
        maxWidth: "none",
      },
    },
    statsSection: {
      // La grille auto-fit gere deja le repli en une colonne sous 220px de
      // large disponible ; on garde seulement la mise en ligne interne des
      // cartes, qui est plus lisible sur mobile.
      "& $statCard": {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
      },
    },
    actionButtons: {
      flexDirection: "column",
      "& button": {
        width: "100%",
        maxWidth: "none",
      },
    },
    paginationContainer: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: "16px",
    },
    paginationInfo: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "12px",
    },
    paginationButtons: {
      width: "100%",
      "& button": {
        flex: 1,
        maxWidth: "none",
      },
    },
  },
  
  "@media (max-width:599.95px)": {
    historyRoot: {
      padding: "15px 20px",
    },
    container: {
      gap: "20px",
    },
    headerSection: {
      padding: "15px",
    },
    headerLeft: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
    statsSection: {
      gap: "12px",
    },
    statCard: {
      padding: "16px 20px",
      minWidth: "auto",
    },
  },
}));

export default useStyles;